<section class="container">
  <div
    id="back-button"
    style="margin-left: 20px; margin-right: 20px; display: flex; justify-content: flex-end"
  >
    <button
      class="back-button"
      mat-button
      (click)="back()"
    >
      <span
        matTooltip="Logout"
        class="material-icons"
      >
        close
      </span>
    </button>
  </div>

  <h1>TERMS AND CONDITIONS</h1>

  <p>Last updated on 20 December 2023</p>

  <p>
    ZippMat Private Limited (hereinafter referred to as the “ZippMat”, “we”, “us”, “our” and terms of similar meaning)
    owns and operates the website (https://zippmat.com/) and domain name, and any other linked pages, features,
    content, mobile applications, or any other services we offer from time to time in connection therewith, to provide
    material supplies and supply chain services for construction companies, manufacturing industries, and other allied
    sectors.
  </p>

  <p>
    These Terms and Conditions (“Terms”) govern your (hereinafter referred to as “you”, “your”, “User”, as applicable)
    access to and/or use of (either as a registered user, visitor/viewer):
  </p>

  <ol>
    <li>
      <a href="https://zippmat.com/">https://zippmat.com/</a>,
      <a href="https://zippmat.in/">https://zippmat.in/</a> including any sub-domains thereof (collectively, “Site”);
    </li>
    <li>
      all related widgets, tools, applications, data, software, APIs, mobile, tablet and other smart device
      applications (collectively, “Application”);
    </li>
    <li>Services (as defined herein below);</li>
  </ol>

  <p>provided by ZippMat from time to time.</p>

  <h2>The Site and the Application together are hereinafter collectively referred to as the “Platform”.</h2>

  <p>
    This document is an electronic record in terms of Information Technology Act, 2000 and rules thereunder as
    applicable and the amended provisions pertaining to electronic records in various statutes as amended by the
    Information Technology Act, 2000 (together with any statutory amendments or modifications thereof). This electronic
    record is generated by a computer system and does not require any physical or digital signatures.
  </p>

  <p>
    PLEASE READ THESE TERMS CAREFULLY BEFORE USING THE PLATFORM. THESE TERMS CONSTITUTE A BINDING, LEGAL AGREEMENT
    BETWEEN YOU AND ZIPPMAT. IN ORDER TO USE THE PLATFORM AND/OR AVAIL OF THE SERVICES, YOU MUST AGREE TO THESE TERMS
    BY CLICKING ON THE 'I AGREE' BUTTON. IF YOU DO NOT AGREE WITH THESE TERMS IN THEIR ENTIRETY, YOU ARE NOT ENTITLED
    TO USE THE PLATFORM OR AVAIL THE SERVICES PROVIDED BY US.
  </p>

  <h3>1. SERVICES</h3>

  <p>
    1.1. Everything offered on the Platform, including but not limited to the below-listed services, are collectively
    referred to in these Terms as the “Services”:
  </p>

  <ol>
    <li>Registration of Users on the Platform;</li>
    <li>
      Facilitation for the Users to fill material enquiry forms, manage orders and track shipment on the Platform;
    </li>
    <li>
      Facilitation of the Users to access the cost-saving calculator, manage customer information, manage shipment and
      fill time-off reports, time-off requests, and timesheets; and
    </li>
    <li>Any other services as we may deem fit from time to time.</li>
  </ol>

  <p>
    1.2. We may, from time to time, release new features on the Platform or introduce other Services. Any such
    additions/amendments will be subject to these Terms as well as any additional terms and conditions that we may
    release for those specific Services or features.
  </p>

  <h3>2. ACCEPTANCE AND GOVERNANCE OF TERMS</h3>

  <p>
    2.1. You hereby expressly acknowledge and agree to be bound by these terms, policies, and guidelines incorporated
    by reference in these Terms, including the Privacy Policy detailed at [●] (“Privacy Policy”) as may be amended from
    time to time.
  </p>

  <p>2.2. You represent and warrant that:</p>

  <ol>
    <li>You are at least 18 (Eighteen) years of age or;</li>
    <li>You have the lawful authority and capacity to contract and be bound by these Terms;</li>
    <li>
      If you are accepting these Terms on behalf of a company, limited liability partnership, trust, or other legal
      entity, you have the authority to bind such entity to these Terms and, in such an event, “You” and “Your” as used
      in these Terms shall refer to such entity; and
    </li>
    <li>You will comply with all applicable laws and regulations.</li>
  </ol>

  <p>
    2.3. These Terms are subject to change at any time without notice. To make sure you are aware of any changes,
    please review these Terms periodically. Continued use of the Platform or Services after any such changes shall
    constitute your consent to such changes.
  </p>

  <p>
    2.4. These Terms are published in compliance with, and are governed by the provisions of applicable Indian laws,
    including but not limited to:
  </p>

  <ol>
    <li>the Indian Contract Act, 1872;</li>
    <li>
      the Information Technology Act, 2000 and the rules, regulations, guidelines, and clarifications framed
      thereunder.
    </li>
  </ol>

  <h3>3. USER ACCOUNT</h3>

  <p>
    3.1. It is not mandatory to register to visit, access, and use the Platform. However, access to the Services is
    only available to registered Users. You need to register and create a user account (“Account”) to avail the
    Services on the Platform by providing your name, email address, mobile number, password, and other details as may
    be requested on the Platform. By registering and creating your Account on the Platform, you agree to:
  </p>

  <ol>
    <li>
      (a) provide accurate, current, and complete information as may be prompted (“Registration Data”) and maintain and
      undertake to update the same in respect of any changes;
    </li>
    <li>(b) maintain the security of your password for the Account;</li>
    <li>
      (c) accept all risks of unauthorized access to the Registration Data and any other information you provide to us;
    </li>
    <li>(d) notify us immediately of any breach of security or any unauthorized use of your Account;</li>
    <li>
      (e) not authorize, assign, or otherwise transfer your Account to any other person or entity or to let them
      operate through the account created and in no event use another User's Account for any purpose or objective; and
    </li>
    <li>
      (f) be responsible for all activity on your Account and to use and operate the same in accordance with applicable
      laws.
    </li>
  </ol>

  <p>3.2. You further agree and confirm that:</p>

  <ol>
    <li>
      (a) You will use the Platform and the Service provided by ZippMat for lawful purposes only and comply with all
      applicable laws and regulations while using the Platform and availing the Services therein;
    </li>
    <li>
      (b) You will provide authentic and true information in all instances where such information is requested of you.
      ZippMat reserves the right to confirm and validate the information and other details provided by you at any point
      in time. If upon confirmation, your details are found not to be true (wholly or partly), it has the right in its
      sole discretion to reject the registration and debar you from using the Services and/or Platform without prior
      intimation;
    </li>
    <li>
      (c) You authorize ZippMat to contact you for providing any of the Services as requested by you, related to your
      Account.
    </li>
  </ol>

  <p>
    3.3. We reserve the right to disallow, cancel, remove, or reassign certain usernames and permalinks in appropriate
    circumstances, as determined by us in our sole discretion and may, with or without prior notice, suspend or
    terminate the Account if activities occur on that Account which, in our sole discretion, would or might constitute
    a violation of these Terms, or an infringement or violation of the rights of any third party, or of any applicable
    laws or regulations. ZippMat may, at its sole discretion, restore access to the Account at any time, pursuant to
    any suspension.
  </p>

  <p>
    3.4. If you register as an authorized person on behalf of another person, you will be fully responsible for
    complying with the Terms and the Privacy Policy. You warrant that at all times you have the authority to seek and
    avail Services or have the explicit authorization on behalf of such other person.
  </p>

  <p>
    3.5. It is your responsibility to keep your correct mobile number and email address updated in the Platform. All
    reminders and notifications will be sent to the account associated with this mobile number and/or email address.
    ZippMat will not be responsible for any loss or inconvenience caused due to your non-updation of your contact
    details.
  </p>

  <h3>4. USE OF THE SERVICE</h3>

  <p>
    4.1. Upon the creation of your Account, you shall be entitled to avail the Services through the Platform. We shall
    provide the Services via our employees, agents, contractors, and/or representatives (“Service Professionals”),
    based on the requirements of the User and based on the Services that the User has signed up for. In addition to
    these Terms, the User also agrees to be bound by the specific terms and conditions as may be applicable and as may
    be published at the time of signing up for the specific Services availed by the User.
  </p>

  <h3>5. ACCESS AND USE</h3>

  <p>
    5.1. ZippMat grants you a limited, personal, non-exclusive, non-transferrable, and non-sub licensable right to use
    the Platform and Services, solely for your own personal, non-commercial use, subject to the Terms. Your access and
    use of the Platform and Services are subject to the following representations and warranties:
  </p>

  <ol>
    <li>(a) You may only access the Platform or Services using authorized and lawful means;</li>
    <li>
      (b) We shall not be liable for any failure or default to provide access to the Platform on account of any failure
      or delay by you to register with the Platform for such access or due to any other reasons whatsoever;
    </li>
    <li>
      (c) Any configuration or set up of the Devices for access to the Platform and the Services shall be your sole
      responsibility. “Device” means a device, usually electronic, that processes data according to a set of
      instructions, which may include but not restricted to workstations, personal computers, laptops, netbooks,
      personal digital assistants, tablets, and smartphones;
    </li>
    <li>
      (d) We collect, store, process, and use your information in accordance with the Privacy Policy. By using the
      Platform and/or by providing your Personal Information (as defined in the Privacy Policy), you consent to the
      collection and use of the information you disclose to us, in accordance with the Privacy Policy;
    </li>
    <li>
      (e) You will not take any action that interferes with, degrades, or adversely affects ZippMat and/or the Services
      and/or the Platform;
    </li>
    <li>
      (f) You will not use the Platform in a manner (i) that is prohibited by any law or regulation or facilitates the
      violation of any law or regulation; or (ii) will disrupt a third party's similar use; (iii) violate or tamper
      with the security of the Platform;
    </li>
    <li>
      (g) You will not use the Platform or any portion thereof to transmit, publish, post, upload, distribute, or
      disseminate any inappropriate, harassing, abusive, defamatory, libelous, obscene, illegal, or deceptive content
      or to sell or promote any products on the Platform;
    </li>
    <li>
      (h) You will not use the Platform or any portion thereof to host, display, upload, modify, publish, transmit,
      store, update, or share any information that:
      <ol type="i">
        <li>belongs to another person and to which the user does not have any right;</li>
        <li>
          is defamatory, obscene, pornographic, pedophilic, invasive of another's privacy, including bodily privacy,
          insulting or harassing on the basis of gender, libelous, racially or ethnically objectionable, relating or
          encouraging money laundering or gambling, or otherwise inconsistent with or contrary to the laws in force;
        </li>
        <li>is harmful to a child;</li>
        <li>infringes any patent, trademark, copyright, or other proprietary rights;</li>
        <li>violates any law for the time being in force;</li>
        <li>
          deceives or misleads the addressee about the origin of the message or knowingly and intentionally
          communicates any information which is patently false or misleading in nature but may reasonably be perceived
          as a fact;
        </li>
        <li>impersonates another person;</li>
        <li>
          threatens the unity, integrity, defense, security, or sovereignty of India, friendly relations with foreign
          States, or public order, or causes incitement to the commission of any cognizable offense or prevents the
          investigation of any offense or is insulting to other nations;
        </li>
        <li>
          contains software virus or any other computer code, file, or program designed to interrupt, destroy, or limit
          the functionality of any computer resource; and
        </li>
        <li>
          is patently false and untrue and is written or published in any form, with the intent to mislead or harass a
          person, entity, or agency for financial gain or to cause any injury to any person.
        </li>
      </ol>
    </li>
    <li>
      (i) You will ensure that the Platform is not used to upload, post, transmit, or otherwise make available any
      content that contains a virus or any other form of malicious code or data that is likely or intended to have an
      adverse impact on, or provide unauthorized access to, the Platform or any other software, hardware, services, or
      data;
    </li>
    <li>
      (j) You shall not use any automated system, including but not limited to, “robots”, “spiders”, “offline readers”,
      “scrapers”, etc., to access the Platform;
    </li>
    <li>
      (k) You will not attempt to gain unauthorized access to any accounts, Service Professionals' information,
      computer systems, or networks connected to the Platform, including but not limited to, names, addresses, phone
      numbers, or email addresses, copying copyrighted text, through hacking, or any other means, or obtain or attempt
      to obtain any materials or information through any means not intentionally made available to you;
    </li>
    <li>
      (l) You will not use, misuse, or misappropriate the Platform to develop, or to assist anyone in developing a
      competitive platform, service, or for other competitive purposes;
    </li>
    <li>
      (m) You will not copy, distribute, or make derivative works of the Platform or any content on the Platform in any
      medium;
    </li>
    <li>
      (n) You shall not recruit, solicit, or contact in any form the Service Professionals for employment or
      contracting for a business not affiliated with ZippMat;
    </li>
    <li>(o) You shall not intentionally submit on the Platform any incomplete, inaccurate, or false information;</li>
    <li>
      (p) You shall be solely responsible for (i) procuring and maintaining your network connections and
      telecommunications links from your systems to ZippMat data centers, and (ii) all problems, conditions, delays,
      delivery failures, and all other loss or damage arising from or relating to your network connections or
      telecommunications links or caused by the internet; and
    </li>
    <li>
      (q) You acknowledge that from time to time, ZippMat may apply Upgrades (hereinafter defined) to the Platform, and
      that such Upgrades may result in changes to the appearance and/or functionality of the Platform. You may be
      required to install certain Upgrades or updates to the software in order to continue to access or use the
      Platform or portions thereof. “Upgrades” means new versions of, and updates to, the Platform, whether for the
      purpose of fixing an error, bug, or other issue in the Platform or enhancing the functionality of the Platform.
    </li>
  </ol>

  <h3>6. LINKS:</h3>

  <p>
    6.1. The Platform may contain links to other websites/platforms controlled by parties other than ZippMat. ZippMat
    is not responsible for and does not endorse the contents or use of these websites/platforms.
  </p>

  <h3>7. FEEDBACK</h3>

  <p>
    7.1. As a visitor/User of the Platform, you agree to use careful, prudent, and good judgment when leaving feedback
    for other Users of the Platform. In the event the feedback violates these Terms, is inappropriate, or violates
    propriety or privacy of another user, ZippMat, in its sole discretion, may take any of the following actions: (i)
    delete your feedback or any of your postings; (ii) limit your Account privileges; (iii) suspend your Account; and
    (iv) report to law enforcement authorities any actions that may be illegal, and any reports it receives of such
    conduct. When legally required or at ZippMat discretion, ZippMat will cooperate with law enforcement agencies in
    any investigation of alleged illegal activity on this Platform.
  </p>

  <p>
    7.2. Reporting inappropriate use of feedback: You may contact ZippMat regarding any inappropriate use of feedback
    via-email to the Grievance Redressal Officer (details of which are provided below).
  </p>

  <p>
    7.3. ZippMat does not and cannot review every posting made on the Platform. These Terms do not require ZippMat to
    monitor, police, or remove any postings or other information submitted by you or any other user, and ZippMat shall
    not be responsible for any ensuing liability.
  </p>

  <h3>8. INTELLECTUAL PROPERTY RIGHTS</h3>

  <p>
    8.1. ZippMat and its licensors, as the case may be, expressly reserve all the intellectual property rights in all
    text, programs, products, processes, technology, content, and other materials apart from Personal Information,
    which appear on this Platform, including the trademarks, logos, and service marks displayed on the Platform
    (“Marks”). You hereby acknowledge that any and all of the intellectual property rights (including but not limited
    to all copyright, patent, Marks, etc.) and other proprietary rights in and in relation to the Platform, including
    without limitation any derivatives, improvements, or modifications which ownership is directly attributable to
    ZippMat or its licensors as the case may be (expressly excluding any information which belongs to a User or other
    third party) and any suggestions, ideas, enhancement requests, feedback, recommendations, or other information
    provided by you or any other party relating to the Platform or the Services shall vest wholly, completely, and
    fully with ZippMat or its licensors throughout the territory of the world, and you shall have no right or claim to
    such intellectual property in any manner whatsoever. All rights, including copyright, in this Platform are owned by
    ZippMat. Any use of this Platform or its contents, including copying or storing it or them in whole or part, other
    than for your own personal, non-commercial use, is prohibited without the permission of ZippMat. You may not
    modify, distribute, or re-post anything on this Platform for any purpose. All software used on this Platform is the
    property of ZippMat or its licensors and protected by Indian and international copyright laws.
  </p>

  <h3>9. INDEMNIFICATION</h3>

  <p>
    9.1. By accepting these Terms and using the Platform and/or availing the Services, you agree that you shall defend,
    indemnify and hold ZippMat, its partners, employees, shareholders, officers, and other representatives harmless
    from and against any and all claims, costs, damages, losses, liabilities, and expenses (including attorneys' fees
    and costs) arising out of or in connection with: (i) Misuse of your access to and use of the Platform and/or the
    Service and/or misuse of any information on the Platform; (ii) any loss or injury to ZippMat representatives or
    Service Professionals resulting from or attributable to your acts or omissions; (iii) your violation or breach of
    these Terms or any applicable law or regulation; (iv) Your violation of any rights of any third party, including
    any intellectual property rights; or (vi) any and all third-party claims based upon (A) the content of any
    communications transmitted by you; and/or (B) transactions undertaken by you; through the Platform.
  </p>

  <h3>10. DISCLAIMER OF WARRANTIES</h3>

  <p>
    10.1. ZippMat hereby explicitly and specifically disclaims any and all representations, warranties, or guarantees
    in respect of the Platform and/or the Services, whether written, oral, expressed, or implied, including, without
    limiting the generality of the foregoing, any warranty of merchantability, quality, or fitness for a particular
    purpose.
  </p>

  <p>
    10.2. The Platform is provided strictly on an “as is” basis. Notwithstanding anything contained in these Terms,
    ZippMat does not warrant that any Platform: (i) will perform error-free or uninterrupted, or that ZippMat will
    correct all or any errors or defects; (ii) will operate in combination with the Devices or with any other hardware,
    software, systems, or data not provided by ZippMat; (iii) will meet the User's requirements, specifications, or
    expectations or that the Services will be available at any particular time or location, uninterrupted or secure.
  </p>

  <p>
    10.3. ZippMat reserves the right at any time and from time to time to modify or discontinue, temporarily or
    permanently, the Platform and/or the Services (or any part thereof) with or without notice and in its sole
    discretion. You agree that ZippMat shall not be liable to you or to any third party for any modification,
    suspension, or discontinuance of the Platform or the Services.
  </p>

  <p>
    10.4. ZippMat shall not be liable to You for any delay or failure in performance of the Services arising out of a
    cause beyond its control and without its fault or negligence. Such causes may include, but are not limited to
    fires, floods, earthquakes, strikes, unavailability of necessary utilities, blackouts, acts of God, acts of
    declared or undeclared war, or acts of regulatory or governmental agencies.
  </p>

  <p>
    10.5. The User acknowledges that ZippMat does not control the transfer of data over the communications facilities,
    including the internet, and that any Platform may be subject to limitations, delays, and other problems inherent in
    the use of such communications facilities. ZippMat shall not be responsible for any (i) delays, delivery failures,
    or other damages as a result; (ii) issues related to the performance, operation, or security of any Platform that
    arise from the User's content or third-party content.
  </p>

  <p>
    10.6. ZippMat does not make any representation or warranty regarding the reliability, accuracy, completeness,
    correctness, or usefulness of third-party content and disclaims all liabilities arising from or related to
    third-party content.
  </p>

  <p>
    10.7. We are not responsible for disputes, claims, losses, injuries, or damage of any kind that might arise out of
    or relate to the conduct of the Users and the third-party sites, including, but not limited to, any User's reliance
    upon any information provided therein. The third-party sites and us are independent contractors, and neither party
    has the authority to make any representations, warranties, or commitments on behalf of the other.
  </p>

  <p>
    10.8. You agree and understand that you shall be responsible for ensuring compliance with the terms of use,
    guidelines, operating rules, and policies of third-party sites. Further, under no circumstances shall ZippMat be
    liable to you or the third-party sites for the services provided by such third-party sites to you. In the event of
    any conflict between these Terms and any of the terms, conditions, and notices contained in any third-party sites,
    the contents of these Terms shall prevail.
  </p>

  <p>
    10.9. We are not responsible for the content, accuracy, or opinions expressed on any third-party sites, and such
    third-party sites are not investigated, monitored, or checked for accuracy or completeness by us. Inclusion of any
    linked third-party sites on the Platform does not imply approval or endorsement of the third-party sites by us.
  </p>

  <p>
    10.10. We reserve the right to modify or remove any content from the Platform, which in our reasonable opinion and
    discretion, does not comply with the above Terms, or if any content is posted that we believe is not in our best
    interest.
  </p>

  <h3>11. LIMITATION OF LIABILITY</h3>

  <p>
    11.1. In no event shall ZippMat or anyone else involved in administering, distributing or providing the Platform
    and/or Services be liable for any direct, special, exemplary, consequential, incidental, punitive, or indirect
    damages, including without limitation damages for loss of profits, goodwill, use, data, or other intangible losses,
    that result from the use of, or inability to use the Platform and/or Services. ZippMat or anyone else involved in
    administering, distributing or providing the Platform and/or Services further explicitly disclaim any and all
    liability for any of the following:
  </p>

  <p>(a) errors, mistakes, or inaccuracies of the content displayed on the Platform;</p>
  <p>
    (b) personal injury or property damage of any nature whatsoever, resulting from our Services or for any alleged or
    actual damages or loss of valuables at the location;
  </p>
  <p>(c) the acts or omissions of our representatives performing Services on our behalf;</p>
  <p>(d) any failure or delay in the Services;</p>
  <p>(e) any content uploaded on the Platform;</p>
  <p>(f) any loss or damage arising out of your failure to adhere to your obligations under the Terms;</p>
  <p>(g) user content or the defamatory, offensive, or illegal conduct of any third party; and</p>
  <p>
    (h) viruses, computer viruses, or other harmful, disabling computer code, computer instructions, circuitry, or
    other technological means whose purpose is to disrupt, damage, or interfere with any computer and communications
    facilities or equipment (“Harmful Code”) that may be transferred to your Devices when accessing the Platform. By
    way of clarification, Harmful Code shall include, without limitation, any code containing viruses, Trojan horses,
    worms, or like destructive code or code that was intentionally written to self-replicate. You are advised to obtain
    and use appropriate anti-virus and security software and to take all other appropriate measures to safeguard the
    integrity of your Devices.
  </p>

  <p>
    11.2. YOU ACKNOWLEDGE AND AGREE THAT THE ENTIRE RISK ARISING OUT OF (I) YOUR USE OF THE PLATFORM; AND/OR (II)
    AVAILING ANY SERVICES, REMAINS SOLELY WITH YOU.
  </p>

  <p>
    11.3. In no event shall ZippMat or anyone else involved in administering, distributing or providing the Platform
    and/or Services be liable to you for any claims, proceedings, liabilities, obligations, damages, losses, or costs
    for an amount exceeding the money charged by ZippMat from the User under which such liability has arisen and been
    established.
  </p>

  <h3>12. TERMINATION</h3>

  <p>12.1. These Terms will continue to apply until terminated by either you or us as set forth below.</p>

  <p>
    12.2. Termination by You: If You wish not to be bound by these Terms, you may terminate your relationship with us
    by (i) not accessing the Platform; and/or (ii) deleting Your Accounts (if any).
  </p>

  <p>
    12.3. Termination by Us: ZippMat may, at its discretion and at any time with or without notice, terminate or
    suspend the Terms, with or without cause if:
  </p>

  <p>
    (a) You breach any of the provisions of the Terms, the Privacy Policy, or any other terms, conditions, or policies
    that may be applicable to you;
  </p>
  <p>
    (b) ZippMat has reasonable grounds for suspecting any illegal, fraudulent, or abusive activity on the part of such
    User;
  </p>
  <p>(c) A third party reports violation of any of its right as a result of Your use of the Services;</p>
  <p>(d) ZippMat is required to do so in accordance with law; or</p>
  <p>
    (e) ZippMat has elected to discontinue, with or without reason, access to the Platform and/or the Services (or any
    part thereof) either in general or specifically to you.
  </p>

  <p>12.4. ZippMat shall not be liable to you or any third party for any such termination.</p>

  <h3>13. CONSEQUENCES OF TERMINATION</h3>

  <p>
    13.1. Once your Account has been terminated, any and all content will be irretrievably deleted by us, except to the
    extent that we are obliged to maintain or permitted to retain in accordance with law. However, your transaction
    details may be preserved by us for purposes of tax or regulatory compliance.
  </p>

  <p>13.2. The licenses granted to you in terms of these Terms shall stand terminated effective immediately.</p>

  <p>13.3. ZippMat, in its sole discretion, may initiate appropriate legal proceedings against you if necessary.</p>

  <p>
    13.4. Termination shall not affect your liability or obligations arising prior to such termination, and any and all
    amounts and charges payable by you pursuant to access or use of the Platform and/or Services shall become
    immediately due and payable.
  </p>

  <h3>14. NOTICE</h3>

  <p>
    14.1. All notices from ZippMat will be served by email to your registered email address or by general notification
    on the Platform. Any notice provided to ZippMat pursuant to the Terms of Use should be sent to
    Priyanka_dhanjani&#64;zippmat.com with the subject line - Attention: “TERMS OF USE”.
  </p>

  <h3>15. GENERAL</h3>

  <p>
    15.1. To the extent that anything in or associated with the Platform is in conflict or inconsistent with these
    Terms, these Terms shall take precedence and prevail. Our failure to enforce any provision of these Terms shall not
    be deemed a waiver of such provision nor of the right to enforce such provision. Our rights under these Terms shall
    survive any discontinuance of the access or use of the Platform and/or Services;
  </p>

  <p>
    15.2. These Terms, together with the Privacy Policy, any agreement entered between you and ZippMat in relation to
    the Platform, and any other specific terms as may be set forth in the Platform, shall constitute the entire
    agreement between you and ZippMat. In the event of any conflict between the Terms and any agreement entered between
    you and ZippMat, the terms of the agreement will prevail, unless otherwise specifically agreed to between the
    parties;
  </p>

  <p>
    15.3. If any provision of these Terms is held to be invalid or unenforceable, such provision shall be struck, and
    the remaining provisions shall be enforced to the fullest extent under law.
  </p>

  <h3>16. DISPUTE RESOLUTION AND GOVERNING LAW</h3>

  <p>
    16.1. If there is a grievance or concern in respect of these Terms or the Services provided by ZippMat, you are
    requested to email us details of the same at Bangalore. Any concern shall be sought to be addressed by ZippMat, and
    in the event of any dispute, you and ZippMat shall endeavor to amicably resolve the dispute.
  </p>

  <p>
    16.2. These Terms shall be governed and construed under the laws of India, and the courts of Bangalore shall have
    exclusive jurisdiction.
  </p>

  <h3>17. GRIEVANCE REDRESSAL MECHANISM</h3>

  <p>
    17.1. ZippMat has constituted an appropriate grievance redressal mechanism within the organization to resolve any
    grievances of the Users. In the event of any clarifications/queries/complaints/grievances in respect of the
    Services and/or the Platform provided by ZippMat, you shall direct the same to the authorized officer by email at
    Priyanka_dhanjani&#64;zippmat.com, who shall ensure that genuine grievances of the Users are redressed promptly.
    The authorized officer shall endeavor to acknowledge the receipt of any complaint within 5 (five) working days and
    redress the complaint within 1 (one) month from the date of receipt of the complaint.
  </p>

  <p>Details of the Authorized Officer:</p>

  <p>Name: Priyanka Dhanjani</p>
  <p>Email: Priyanka_dhanjani&#64;zippmat.com</p>
  <p>Phone: +91 9364007925</p>
  <p>
    Address: Municipal No. 7 (Old No. 333), PID No. 99-27-7, 14th Main Road, 6th 'A' Cross, Rajamahal Vilas Extension,
    Sadashivanagar, Bangalore – 560 080
  </p>

  <p>
    BY USING THE PLATFORM AND/OR BY AVAILING THE SERVICES, YOU SIGNIFY THAT YOU HAVE READ AND UNDERSTOOD THE TERMS AND
    AGREE TO THESE TERMS, INCLUDING THE PRIVACY POLICY PROVIDED HEREIN. THESE TERMS CONSTITUTE A BINDING AND LEGAL
    AGREEMENT BETWEEN YOU AND ZIPPMAT. ZIPPMAT RESERVES THE RIGHT, AT ITS SOLE DISCRETION, TO CHANGE, MODIFY, ADD, OR
    REMOVE PORTIONS OF THESE TERMS, AT ANY TIME. IT IS YOUR RESPONSIBILITY TO CHECK THESE TERMS PERIODICALLY FOR
    CHANGES. EVERY ACCESS BY YOU OF THE PLATFORM AND/OR AVAILMENT OF SERVICES IS DEEMED TO MEAN THAT YOU HAVE AGREED TO
    ACCEPT AND ADHERE TO THE TERMS AS AMENDED AND APPLICABLE AT SUCH TIME.
  </p>
</section>
